module.exports = "/images/sacoa.svg?fe64f5c005f91d5c9470536c94e5fad5";